import * as React from 'react'
import Layout from '../components/layout'
import {
  lightFont,
  indent1,
  inputGroup,
  stoneLabel,
  stoneInput,
  presetButton,
} from './calculator.module.css'
import { getLang } from '../components/common.js'
import {
  monocleBonusDict,
  chaliceBonusDict,
} from '../components/artifacts-data.js'

export default class ContractBoostCalculatorPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tachMult: 1000,
      bbMult: 10,
      baseBoostTime: 10,
      monocle: "None",
      chalice: "None",
      lifeStonesT2: "",
      lifeStonesT3: "",
      lifeStonesT4: "",
      dilithiumStonesT2: "",
      dilithiumStonesT3: "",
      dilithiumStonesT4: "",
      boostEventMult: 1,
      ihr: 7440,
  
      totalChickensOffline: "",
      totalChickensOnline: "",
      boostedIhr: "",
      totalBoostTime: "",
    }
  }

  handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({[name]: value}, this.contractBoost);
  }

  handlePreset = event => {
    const target = event.target;
    const name = target.name;

    if (name === "token14") {
      this.setState({
        tachMult: 1000,
        bbMult: 10,
        baseBoostTime: 10,
      }, this.contractBoost);
    }
    else if (name === "token19") {
      this.setState({
        tachMult: 100,
        bbMult: 6,
        baseBoostTime: 30,
      }, this.contractBoost);
    }
    else if (name === "token19legacy") {
      this.setState({
        tachMult: 300,
        bbMult: 4,
        baseBoostTime: 20,
      }, this.contractBoost);
    }
    else if (name === "bensonspecial") {
      this.setState({
        tachMult: 1000,
        bbMult: 2,
        baseBoostTime: 10,
      }, this.contractBoost);
    }
    else if (name === "token8") {
      this.setState({
        tachMult: 200,
        bbMult: 1,
        baseBoostTime: 120,
      }, this.contractBoost);
    }
  }

  contractBoost = () => {
    const monocleMult = 1 + monocleBonusDict[this.state.monocle];
    const chaliceMult = 1 + chaliceBonusDict[this.state.chalice];
    const lifeMult = Math.pow(1.02, parseInt(this.state.lifeStonesT2 | 0)) * Math.pow(1.03, parseInt(this.state.lifeStonesT3 | 0)) * Math.pow(1.04, parseInt(this.state.lifeStonesT4 | 0));
    const dilithiumMult = Math.pow(1.03, parseInt(this.state.dilithiumStonesT2 | 0)) * Math.pow(1.06, parseInt(this.state.dilithiumStonesT3 | 0)) * Math.pow(1.08, parseInt(this.state.dilithiumStonesT4 | 0));

    const boostedIhrValue = this.state.ihr * this.state.tachMult * monocleMult * chaliceMult * lifeMult * this.state.bbMult;
    const totalTime = this.state.baseBoostTime * dilithiumMult * this.state.boostEventMult;
    const totalChickensOnlineValue = boostedIhrValue * totalTime * 4;
    const totalChickensOfflineValue = 3 * totalChickensOnlineValue;

    const lang = getLang();
    const options = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    };

    const totalTimeMin = Math.floor(Math.round(totalTime))
    const totalTimeSec = Math.round(totalTime) * 60 - totalTimeMin * 60
    const totalTimeStr = totalTimeMin.toLocaleString(lang, options) + "m " + totalTimeSec.toLocaleString(lang, options) + "s";

    this.setState({totalChickensOffline: totalChickensOfflineValue.toLocaleString(lang, options)});
    this.setState({totalChickensOnline: totalChickensOnlineValue.toLocaleString(lang, options)});
    this.setState({boostedIhr: boostedIhrValue.toLocaleString(lang, options)});
    this.setState({totalBoostTime: totalTimeStr.toLocaleString(lang, options)});
  };

  render() {
    return (
      <Layout pageTitle="Contract Boost Calculator">
        <h1 className={lightFont}>Contract Boost Calculator</h1>
        <p className={indent1}>Computes number of chickens for a boost set. Assumes max ER.</p>

        <h2 className={lightFont}>Inputs</h2>

        <div className={indent1}>
          <div className={inputGroup}>
            <div>Boost Set Presets</div>
            <button className={presetButton} name="token14" onClick={this.handlePreset} title="1000x tach and 10x bb for 10m">14 Token</button>
            <button className={presetButton} name="token19" onClick={this.handlePreset} title="100x 2hr tach and 3 2x bb for 30m">19 Token</button>
            <button className={presetButton} name="token19legacy" onClick={this.handlePreset} title="3 100x 20m tach (legacy) and 2 2x bb for 30m">19 Token Legacy</button>
            <button className={presetButton} name="bensonspecial" onClick={this.handlePreset} title="1000x tach and 2x bb for 10m">11 Token Benson Special</button>
            <button className={presetButton} name="token8" onClick={this.handlePreset} title="2 100x tach for 2h">8 Token</button>
          </div>
          <div className={inputGroup}>
            <div>Tachyon Prism Multiplier (Multiple of these will stack additively.)</div>
            <input name="tachMult" type="number" min="1" value={this.state.tachMult} placeholder="10, 100, 1000, ..." onInput={this.handleInputChange} />
          </div>
          <div className={inputGroup}>
            <div>Boost Beacon Multiplier (Multiple of these will stack additively.)</div>
            <input name="bbMult" type="number" min="1" value={this.state.bbMult} placeholder="2, 10, ..." onInput={this.handleInputChange} />
          </div>
          <div className={inputGroup}>
            <div>Base Boost Time (minutes)</div>
            <input name="baseBoostTime" type="number" min="1" value={this.state.baseBoostTime} onInput={this.handleInputChange} />
          </div>
          <div className={inputGroup}>
            <div>Monocle</div>
            <select name="monocle" value={this.state.monocle} onChange={this.handleInputChange}>
              {Object.keys(monocleBonusDict).map(key => (
                <option>{key}</option>
              ))}
            </select>
          </div>
          <div className={inputGroup}>
            <div>Chalice</div>
            <select name="chalice" value={this.state.chalice} onChange={this.handleInputChange}>
              {Object.keys(chaliceBonusDict).map(key => (
                <option>{key}</option>
              ))}
            </select>
          </div>
          <div className={inputGroup}>
            <div>Total Life Stones</div>
            <div>
              <label className={stoneLabel} htmlFor="lifeStonesT2">T2:</label>
              <input className={stoneInput} name="lifeStonesT2" type="number" min="0" value={this.state.lifeStonesT2} onInput={this.handleInputChange} />
              <label className={stoneLabel} htmlFor="lifeStonesT3">T3:</label>
              <input className={stoneInput} name="lifeStonesT3" type="number" min="0" value={this.state.lifeStonesT3} onInput={this.handleInputChange} />
              <label className={stoneLabel} htmlFor="lifeStonesT4">T4:</label>
              <input className={stoneInput} name="lifeStonesT4" type="number" min="0" value={this.state.lifeStonesT4} onInput={this.handleInputChange} />
            </div>
          </div>
          <div className={inputGroup}>
            <div>Total Dilithium Stones</div>
            <div>
              <label className={stoneLabel} htmlFor="dilithiumStonesT2">T2:</label>
              <input className={stoneInput} name="dilithiumStonesT2" type="number" min="0" value={this.state.dilithiumStonesT2} onInput={this.handleInputChange} />
              <label className={stoneLabel} htmlFor="dilithiumStonesT3">T3:</label>
              <input className={stoneInput} name="dilithiumStonesT3" type="number" min="0" value={this.state.dilithiumStonesT3} onInput={this.handleInputChange} />
              <label className={stoneLabel} htmlFor="dilithiumStonesT4">T4:</label>
              <input className={stoneInput} name="dilithiumStonesT4" type="number" min="0" value={this.state.dilithiumStonesT4} onInput={this.handleInputChange} />
            </div>
          </div>
          <div className={inputGroup}>
            <div>Boost Event Duration Multiplier</div>
            <input name="boostEventMult" type="number" min="1" value={this.state.boostEventMult} onInput={this.handleInputChange} />
          </div>
          <div className={inputGroup}>
            <div>IHR (You probably don't need to change this.)</div>
            <input name="ihr" type="number" min="0" value={this.state.ihr} onInput={this.handleInputChange} />
          </div>
        </div>

        <h2 className={lightFont}>Results</h2>

        <div className={indent1}>
          <div>Total Chickens (Offline)</div>
          <input name="totalChickensOffline" value={this.state.totalChickensOffline} readOnly />
          <div>Total Chickens (Online)</div>
          <input name="totalChickensOnline" value={this.state.totalChickensOnline} readOnly />
          <div>Boosted IHR</div>
          <input name="boostedIhr" value={this.state.boostedIhr} readOnly />
          <div>Total Boost Time</div>
          <input name="totalBoostTime" value={this.state.totalBoostTime} readOnly />
          <br/>
          <br/>
        </div>

      </Layout>
    )
  }
}